import Vue from "vue";
import VueI18n from "vue-i18n";
import config from "../configs";

const { locale, availableLocales, fallbackLocale } = config.locales;

/**
 * Vue Translations
 * https://kazupon.github.io/vue-i18n/
 */
Vue.use(VueI18n);

const messages = {};
// @ts-ignore
availableLocales.forEach((l) => { messages[l.code] = l.messages; });

export const i18n = new VueI18n({
  locale,
  fallbackLocale,
  messages
});
// @ts-ignore
i18n.locales = availableLocales;

export type TranslateFunction = (key: string, values?: VueI18n.Values) => string;

export const toTranslateFunction = (t: any): TranslateFunction => {
  return (key: string, values?: VueI18n.Values): string => {
    return String(t(key, values));
  };
};

export const useI18n = (vm: { proxy: Vue } | null) => {
  let translate: TranslateFunction = (key: string, values?: VueI18n.Values): string => {
    return key;
  };
  if (!vm) {
    return {translate};
  }

  translate = (key: string, values?: VueI18n.Values): string => {
    return String(vm.proxy.$t(key, values));
  };

  return {translate};
};
